import { b2x } from '@b2x/react/src';

import { Container } from '../Container';
import { InviteFriendPageContentType } from '../contentTypes';
import { t } from '../i18n/i18n';
import { ReferralBanner } from '../ReferralBanner';
import { customerIsVet } from '../util';
import { Page } from './Page';

export const InviteFriendPage = () => {
  const page = b2x.usePage<InviteFriendPageContentType>({
    populate: {
      products: b2x.appConfig.api?.productTilePopulate,
    },
  });

  const { session } = b2x.useAppContext();

  const body = page?.content?.body;
  const referralBox = body?.referralBox;

  const referralType = body?.referralType;

  const isVet = session?.customer?.qualifiers && customerIsVet(session.customer.qualifiers);

  return (
    <Page className="invite-friend-page" noPaddingBottom noPaddingTop thingsToLoadBeforePageReady={[page]}>
      <ReferralBanner {...body?.banner} />
      <Container>
        <b2x.Div marginY={{ lg: 5, xs: 0 }}>
          <b2x.ReferralBox
            {...referralBox}
            sharingOptions={{
              alternativeText: t('misc.inviteFrient.sharingOptions.alternativeText'),
              disableSharing: referralType === 'Vet' && !isVet ? true : false,
              friendType: referralType === 'Vet' ? referralType : undefined,
              pageCode: referralType === 'Vet' ? 'SITE_REGISTER_VET' : undefined,
            }}
          />
        </b2x.Div>
      </Container>
    </Page>
  );
};
